import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=f1ede62e&scoped=true"
import script from "./PendingOrders.vue?vue&type=script&lang=js"
export * from "./PendingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ede62e",
  null
  
)

export default component.exports